export const companyInfo = {
  name: "Peter Sloth",
  owner: "Peter Sloth",
  address: "Åstruplundvej 26, 8740 Brædstrup",
  phone: "51 81 51 75",
  phoneFormatted: "+4551815175",
  email: "psa1997@outlook.com",
  cvr: "41629622",
  tagline: "Vi går ikke på kompromis med kvalitet",
  areas: ["Horsens", "Silkeborg", "Skanderborg", "Brædstrup"],
  aboutTitle: "Entreprenør, der kan klare de fleste opgaver",
  aboutSubtitle: "Alt arbejde indenfor bl.a. terrændæk, sokkel, belægning og støttemur",
  aboutDescription1: "Leder du efter en professionel entreprenør i Horsens, Silkeborg, Skanderborg eller et andet sted i landet? Hos entreprenørfirmaet Peter Sloth hjælper vi private og erhvervskunder i hele landet - og der er stort set ikke den opgave vi ikke kan klare.",
  aboutDescription2: "Vi arbejder fleksibelt og ønsker altid at skabe et godt og transparent samarbejde med kunder og eventuelle andre håndværkere. Vi tror nemlig på at de bedste resultater kommer fra et godt og trygt samarbejde.",
  servicesList: [
    "Støbning af sokkel og fundament",
    "Terrændæk",
    "Belægning",
    "Støttemure",
    "Gravearbejde",
    "Nedbrydning"
  ]
};

export const openingHours = [
  { day: "Mandag", hours: "07.00 - 18.00" },
  { day: "Tirsdag", hours: "07.00 - 18.00" },
  { day: "Onsdag", hours: "07.00 - 18.00" },
  { day: "Torsdag", hours: "07.00 - 18.00" },
  { day: "Fredag", hours: "07.00 - 18.00" },
  { day: "Lørdag", hours: "07.00 - 18.00" },
  { day: "Søndag", hours: "07.00 - 18.00" }
];

export const services = [
  {
    id: "sokkel",
    title: "Sokkel",
    subtitle: "Støbning af sokkel og fundament",
    image: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/9c157175-e0c3-4444-831d-d0eb95c3213e.jpeg",
    description: "Vi tilbyder professionel støbning af sokkel og fundament til både private og erhverv. Et solidt fundament er afgørende for ethvert byggeri, og vi sikrer, at arbejdet udføres præcist og efter alle gældende standarder.",
    detailedText: "Uanset om du skal bygge nyt hus, en tilbygning, en garage eller en industribygning, står vi klar til at støbe fundamentet. Vi har stor erfaring med jord- og betonarbejde, hvilket sikrer dig et resultat, der holder i mange år. Vi rådgiver gerne om de bedste løsninger til dit specifikke projekt."
  },
  {
    id: "terraendaek",
    title: "Terrændæk",
    subtitle: "Etablering af terrændæk",
    image: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/9a4a8761-f04f-4361-9c81-6335c4a01814.jpeg",
    description: "Etablering af terrændæk med fokus på korrekt isolering og radonsikring. Vi udfører terrændæk til både boliger, haller og erhvervsbygninger.",
    detailedText: "Et terrændæk skal opbygges korrekt med det rette lag af sand, isolering, armering og beton. Vi sørger for, at alle krav til isoleringsevne og tæthed mod radon overholdes til punkt og prikke. Med vores ekspertise får du et plant og solidt gulv, der er klar til den efterfølgende belægning."
  },
  {
    id: "belaegning",
    title: "Belægning",
    subtitle: "Flotte og holdbare belægningsløsninger",
    image: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/94d11d36-21e6-4fb1-9c34-46bcfa490cd1.jpeg",
    description: "Flotte og holdbare belægningsløsninger til indkørsler, terrasser, gangstier og parkeringspladser. Vi arbejder med mange forskellige typer sten og fliser.",
    detailedText: "En flot belægning fuldender husets udtryk. Vi udfører alt fra mindre terrasser og gangstier to store indkørsler og parkeringsarealer. Vi lægger stor vægt på det indledende bundopbygningsarbejde, da det er afgørende for, at belægningen forbliver jævn og stabil i mange år uden sætningsskader."
  },
  {
    id: "stoettemur",
    title: "Støttemur",
    subtitle: "Opbygning af støttemure",
    image: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/b09dbddd-d16a-471d-b104-78567c45c42d.jpeg",
    description: "Opbygning af støttemure til niveauforskelle i haven eller på erhvervsarealer. Vi sikrer en stabil og æstetisk løsning, der holder terrænet på plads.",
    detailedText: "Støttemure er en ideel løsning til at udnytte kuperet terræn eller skabe spændende niveauforskelle i haven. Vi opbygger støttemure i betonsten, herregårdssten eller andre materialer, der passer til omgivelserne. Vi sørger for korrekt afvanding og solidt bagstøb, så muren kan modstå jordtrykket."
  },
  {
    id: "gravearbejde",
    title: "Gravearbejde",
    subtitle: "Alt inden for gravearbejde",
    image: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/2c39db84-c3ce-4aaa-865c-4c5f33836911.jpeg",
    description: "Alt inden for gravearbejde, herunder udgravning til fundamenter, veje, søer samt afretning af grunde. Vi råder over en moderne maskinpark.",
    detailedText: "Vi udfører alle former for gravearbejde for private, erhverv og offentlige instanser. Vores erfarne maskinførere klarer alt fra præcisionsudgravning til større jordflytninger. Vi har maskiner i flere størrelser, så vi kan komme til overalt – uanset om det er i en lukket parcelhushave eller på en stor byggeplads."
  },
  {
    id: "nedbrydning",
    title: "Nedbrydning",
    subtitle: "Sikker og effektiv nedbrydning",
    image: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/48a9f646-1223-402b-a825-91b6aa39187f.jpeg",
    description: "Sikker og effektiv nedbrydning af huse, garager, staldbygninger og betonkonstruktioner. Vi sørger for korrekt sortering og bortskaffelse af affald.",
    detailedText: "Skal du have fjernet en gammel bygning for at gøre plads til nyt? Vi tilbyder total- og delnedbrydning af alle typer mindre bygninger. Sikkerhed og miljøhensyn er i højsædet, og vi sørger altid for, at alle materialer sorteres korrekt efter gældende miljøregler, så genanvendelige materialer udnyttes bedst muligt."
  }
];

export const collageImages = {
  top: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/4852a2a8-a097-4ddb-b428-a0845acd9f82.webp",
  bottomLeft: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/a9f93943-6ede-4887-a637-6ab0d1dfedab.webp",
  bottomRight: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/6595eb7d-5835-456f-a2fa-3af3065c5789.webp"
};

export const portfolioImages = [
  // Gravearbejde
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/c0fbcc2d-c7b1-4713-999d-2621a3d413ba.webp",
    alt: "Gravearbejde i Silkeborg, Brædstrup, Horsens og Skanderborg",
    category: "Gravearbejde"
  },

  // Belægning
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/53877166-55b8-49b7-b07f-244725288920.jpeg",
    alt: "Belægningsarbejde i indkørsel",
    category: "Belægning"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/5ed7fc16-5548-43ce-8b11-a094bce575ab.png",
    alt: "Belægning til udendørs trappe i Brædstrup",
    category: "Belægning"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/94d11d36-21e6-4fb1-9c34-46bcfa490cd1.jpeg",
    alt: "Belægning rundt om huset i Silkeborg",
    category: "Belægning"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/bba6f421-4f43-4e43-a300-8973f24a229d.png",
    alt: "Flot belægningsarbejde i Brædstrup",
    category: "Belægning"
  },

  // Støttemur
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/b09dbddd-d16a-471d-b104-78567c45c42d.jpeg",
    alt: "Opbygning af støttemur",
    category: "Støttemur"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/c27fdb92-9c1b-4ca6-bd1d-8cd061074130.jpeg",
    alt: "Opsætning af støttemur i have",
    category: "Støttemur"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/56e193ba-1064-4891-888b-a58ab4131270.jpeg",
    alt: "Støttemur til erhvervsareal",
    category: "Støttemur"
  },

  // Sokkel
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/35737e8e-0981-4e2f-bacf-9705d6f68055.png",
    alt: "Støbning af Sokkel i Horsens",
    category: "Sokkel"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/25a302f3-c48f-48aa-a182-285928a03072.jpeg",
    alt: "Støbning af fundament og sokkel i Skanderborg",
    category: "Sokkel"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/0bc22b6a-8943-48bb-8c11-0f17cc936de5.jpeg",
    alt: "Støbning af sokkel og fundament i Silkeborg",
    category: "Sokkel"
  },

  // Terrændæk
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/dae40cb9-4c23-41d3-8148-fc7f252da84b.webp",
    alt: "Terrændæk og betonarbejde",
    category: "Terrændæk"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/dc5cc3a7-162a-41a3-91a5-772b64329395.png",
    alt: "Terrændæk i Horsens",
    category: "Terrændæk"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/cb862fb4-5a1d-4be2-92c3-3918aba07c61.jpeg",
    alt: "Terrændæk i Silkeborg",
    category: "Terrændæk"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/073de3ab-83b8-4cff-9963-d69bc1bab473.jpeg",
    alt: "Terrændæk i Skanderborg",
    category: "Terrændæk"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/f26942e8-a441-41a9-937b-1edf6d7a7363.jpeg",
    alt: "Terrændæk i hal",
    category: "Terrændæk"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/ba03a01c-1ffe-4729-8011-6f2b46688542.jpeg",
    alt: "Fundament og terrændæk",
    category: "Terrændæk"
  },

  // Gravearbejde
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/52529e14-f491-48ce-8b7a-d8d5e43c1748.webp",
    alt: "Gravearbejde i Silkeborg",
    category: "Gravearbejde"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/9614c5e9-e03d-44c4-960d-aa2b5c55f714.webp",
    alt: "Gravearbejde med rendegraver",
    category: "Gravearbejde"
  },
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/920d6443-7c40-4805-ac0a-7f081fd5a513.jpeg",
    alt: "Større gravearbejde med stor kran i Brædstrup",
    category: "Gravearbejde"
  },

  // Nedbrydning
  {
    url: "https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/deaca40f-8458-4bf3-8ddf-70609e606174.webp",
    alt: "Nedbrydning af murstenshus",
    category: "Nedbrydning"
  }
];
